import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import DatePicker from "components/DatePicker/DatePicker";
import { Textbox } from "components/Textbox/Textbox";
import { Time } from "components/Time/Time";
import { AssignTypes } from "pages/OfficeAutomation/Cartable/types";
import React, { useContext, useEffect, useRef, useState } from "react";
import { trans, uuidv4 } from "utils/helpers";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ENDPOINTS } from "utils/endpoints";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { GUID_EMPTY } from "utils/constants";
import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";


export const ReferenceForm: React.FC<any> = ({showsaveAndRefrence=true,initialData,selectAtLeastOneTask , taskMode=false,PositionTitle , taskTitle, jobId, TAS_UID,TAS_TITLE, Id ,PerformerPositionId,ReferrerPositionId,ParentReferenceId,
    handleSubmitedData, allFormData, setShowForm, showForm, isAllForms, handleSubmitedDataForAllForms ,assignType }) => {
    let data
    const [resetForm, setResetForm] = useState(false);
    const [fromDate, setFromDate] = useState<string>();
    const [actualTimeInputValue, setActualTimeInputValue] = useState<string>("00:00");
   const [formData, setFormData] = useState<any>();
     let layoutContext = useContext(LayoutContext);
    const currentFormData =  allFormData.find(obj => (obj.Id == Id && obj.TAS_UID == TAS_UID)) 

  const SubmitRef = useRef<any>(false);
  const formRef=useRef<any>()


    const formSubmit = async (event) => {
        event.preventDefault()
        let array = actualTimeInputValue.split(":");


        if (!isAllForms) {
            data = {
                AssignType : AssignTypes[assignType],
                ParentReferenceId:ParentReferenceId,
                Id: Id?Id: uuidv4(),
                TAS_UID,
                TAS_TITLE,
                JobId: jobId,
                PerformerPositionId,
                ReferrerPositionId: layoutContext.currentUserPosition?.SubstitutePositionId?layoutContext.currentUserPosition?.SubstitutePositionId:ReferrerPositionId,
                ReferenceSubjectId: event.target.referenceSubject.value,
                Position: event.target.position.value,
                Description: event.target.description.value,
                ReferenceSubject: event.target.referenceSubject.key,
                Priority: +event.target.priority.value,
                EstimateTime: +event.target.estimateTime[0].value,
                DeadLineDate: fromDate,
                HasFollowUp: event.target.hasFollowUp.checked,
                SecretReference: event.target.secretReference.checked,
                SendMessageToPerformer: event.target.sendMessageToPerformer.checked,
            }
            await setFormData(data)
        } else {
            data = {
                AssignType : AssignTypes[assignType],
                ParentReferenceId:ParentReferenceId,
                Id: undefined,
                TAS_UID,
                TAS_TITLE,
                JobId: jobId,
                PerformerPositionId: undefined,
                ReferrerPositionId:layoutContext.currentUserPosition?.SubstitutePositionId?layoutContext.currentUserPosition?.SubstitutePositionId:ReferrerPositionId,
                ReferenceSubjectId: event.target.referenceSubject.value,
                Position: undefined,
                Description: event.target.description.value,
                ReferenceSubject: event.target.referenceSubject.key,
                Priority: +event.target.priority.value,
                EstimateTime: +event.target.estimateTime[0].value,
                DeadLineDate: fromDate,
                HasFollowUp: event.target.hasFollowUp.checked,
                SecretReference: event.target.secretReference.checked,
                SendMessageToPerformer: event.target.sendMessageToPerformer.checked,
            }

            await setFormData(data)
        }


        await setShowForm(false)
       
    }

    const isSubmitted = (formData !== undefined || null) && (isAllForms === false)

    const isAllformSubmitted = (formData !== undefined || null) && (isAllForms === true)


    useEffect(() => {
        if (!isAllForms) { handleSubmitedData(formData, TAS_UID ,SubmitRef.current ) }
    }, [isSubmitted]);

    useEffect(() => {
        if (isAllForms) { handleSubmitedDataForAllForms(formData, TAS_UID,SubmitRef.current) }
    }, [isAllformSubmitted]);

    useEffect(()=>{
    if(formRef.current) {
        formRef.current?.description?.select()
    }
    if(PerformerPositionId==GUID_EMPTY){
        Toast(trans(PositionTitle), MessageType.error);
    }
    },[formRef.current])

    return (
        <form ref={formRef} onSubmit={formSubmit}>
            <div className={`${taskMode ? "list-card mt-3" :  " card" } `  }>
                <FormWithTitle showTitle={taskMode} textAnimation={'shaking_animation'} title={trans("receiver")+" " +trans("referenceForm") +" : " +PositionTitle}>
                <div className="card-body">
                    <div className="container">
                        <div className="row my-1">
                            <div className="col-12 my-1 my-lg-0 col-lg-3">
                                <DictionarySelectBox
                                    required={true}
                                    label="referenceSubject"
                                    name='referenceSubject'
                                    endPoint={ENDPOINTS.cartable.referenceSubject.dictionary}
                                    value={currentFormData ? currentFormData.ReferenceSubjectId : ''}
                                />

                            </div>
                            <div className="col-12 my-1 my-lg-0 col-lg-3">
                                <EnumerationTypeSelect
                                    required={true}
                                    label="priority"
                                    name='priority'
                                    enumTypeSelect="priority"
                                    value={currentFormData ? currentFormData.Priority : null}
                                />
                            </div>
                            <div className="col-4 my-1 my-lg-0 col-lg-3">
                                <DatePicker
                                    onOpenPickNewDate={false}
                                    lable='DeadLineDate'
                                    resetForm={resetForm}
                                    type='date'
                                    setIsoTime={(isoTime: string) => { setFromDate(isoTime) }}
                                    val={currentFormData?.DeadLineDate  ? currentFormData.DeadLineDate :null}
                                />
                            </div>
                            
                            <div className="col-4 my-1 my-lg-0 col-lg-3">
                                <Time
                                    name="estimateTime"
                                    IdString="estimateTime"
                                    resetForm={resetForm}
                                    defaultValue={currentFormData?.EstimateTime}
                                    label="estimateTime"
             
                                />
                            </div>
                        </div>
                        <div className="row my-1">

                            <div className="col-4 my-1 my-lg-0 col-lg-2 pt-4">
                                <CheckableButton
                                    type='checkbox'
                                    labelText='HasFollowUp'
                                    defaultChecked={currentFormData ? currentFormData.HasFollowUp : false}
                                    inputName='hasFollowUp'
                                />
                            </div>
                            <div className="col-4 my-1 my-lg-0 col-lg-2 pt-4">
                                <CheckableButton
                                    type='checkbox'
                                    labelText='SecretReference'
                                    defaultChecked={currentFormData ? currentFormData.SecretReference : false}
                                    inputName='secretReference'
                                />
                            </div>
                            <div className="col-4 my-1 my-lg-0 col-lg-4 pt-4">
                                <CheckableButton
                                       defaultValue={false}
                                       labelText={"sendMessageToPerformer"}
                                       inputName={"sendMessageToPerformer"}
                                       type="checkbox"
                                       mode={"edit"}
                                    />    
                            </div>

                           
                        </div>

                        <div className="row mt-3 mb-1">
                            <div className="col-12">
                                <Textbox
                                    textboxType="textarea"
                                    textboxName="description"
                                    resetForm={resetForm}
                                    defaultValue={currentFormData?.Description.length >0? currentFormData.Description : ( taskTitle ?taskTitle  :"")}
                                    labelText="Description"
                                />
                            </div>
                        </div>
                        <div className="row my-1">
                            {!isAllForms && <div className="d-none col-12 my-1 my-lg-0 col-lg-6">
                                <Textbox
                                    required={true}
                                    textboxType="text"
                                    textboxName="position"
                                    resetForm={resetForm}
                                    defaultValue={currentFormData ? currentFormData.Position : ""}
                                    labelText="Position"
                                    mode={'view'}
                                />
                            </div>}
                        </div>

                        <div className="row mt-3 mb-4">
                        </div>
                        <div className="row mt-3 d-flex flex-row-reverse">
                            <div className="col-12 d-flex align-items-center justify-content-end">
                                <Button disabled={PerformerPositionId==GUID_EMPTY} btnType="submit" value={ taskMode ?"Reference": 'submit'} />
                                {((!taskMode )&&showsaveAndRefrence && assignType != "SELF_SERVICE") && (selectAtLeastOneTask && !initialData?.some(item=>item?.AssignType=="SELF_SERVICE") ) &&
                                //if one of AssignType of tasks is "SELF_SERVICE" should not show button
                                //beacuse SELF_SERVICE task might be not complete 
                                //if selectAtLeastOneTask is false and user should ckeck all task SELF_SERVICE task might be not complete 
                                <Button disabled={PerformerPositionId==GUID_EMPTY } btnType="submit" value={'SaveAndReffer'} onClick={(e)=>{SubmitRef.current = true}} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                </FormWithTitle>
            </div>
        </form>
    )
}